mtl.alloy.factory['id-verification-form'] = (function($) {
	'use strict';
	
	return function(element, options)
	{
		$(element).on('submit', function(event)
		{
			if($(element).find('input[value="upload_photo"]').prop('checked'))
			{
				return;
			}

			if($(element).find('#app_checkout_verification_file').val()=="")
			{
				return;
			}

			if($(element).find('#app_checkout_verification_file1').val()=="")
			{
				return;
			}

			if(confirm('You have uploaded files to verify your identity but have chosen not to submit them. Do you wish to continue?') )
			{
				return;
			}

			event.preventDefault();
		}

		)
	}

}(jQuery));
